<!--
 * @Description: 劳务用工详情页
-->
<template>
  <div class="FlexibleDetail_page">
    <EmptyData :type="state" v-if="state != 1">
      当前数据已{{ state == 2 ? "下架" : "删除" }}，点击
      <a @click="handleBack">返回列表</a> 继续浏览吧~
    </EmptyData>

    <div
      class="leftBox"
      v-loading="loadingTrue"
      element-loading-background="rgba(255, 255, 255, 1)"
      v-if="state == 1"
    >
      <div class="item_top">
        <div class="title">
          <div class="name">
            <span
              class="state"
              v-if="Detail.employmentStatus"
              :style="
                Detail.employmentStatus === 1
                  ? { backgroundColor: '#e1251b' }
                  : ''
              "
            >
              {{ Detail.employmentStatusName }}
            </span>
            <span class="titleName">{{ Detail.workName }}</span>
          </div>
        </div>
        <div class="detailBody">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-top:20px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/danwei.png" alt="" />
                </span>
                <span class="color6">劳务行业：</span>
                <span class=" color3">{{ Detail.industryName }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-top:20px">
                <span class="item_icon">
                  <img src="@/assets/temporary/leibie.png" alt="" />
                </span>
                <span class="color6">劳务类别：</span>
                <span class=" color3">{{ Detail.categoryName }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-top:20px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/xinzi.png" alt="" />
                </span>
                <!-- 薪资： -->
                <span class="color6">薪资方式：</span>
                <span class=" color3">{{
                  Detail.salaryTypeName
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom: 0">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/renshu.png" alt="" />
                </span>
                <span class="color6">用工人数：</span>
                <span class=" color3">{{
                  Detail.employmentNumber ? Detail.employmentNumber + "人" : ""
                }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom: 0">
                <span class="item_icon">
                  <img src="@/assets/temporary/shichang.png" alt="" />
                </span>
                <span class="color6">用工时间：</span>
                <span class=" color3" v-if="Detail.employmentTime">
                  {{Detail.employmentTime|formatDate}}
                </span>
                <span class=" color3" v-else>/</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom: 0">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/dizhi.png" alt="" />
                </span>
                <span class="color6">工作地址：</span>
                 <div @mouseenter="handleShowTooltip($event)">
                  <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom"  class="single_hide" effect="light">
                    <div class="color0 single_hide" @click="showMap" style="max-width:222px;">{{ Detail.areaName?Detail.provinceName + Detail.cityName + Detail.areaName + (Detail.address ?  Detail.address : '') :Detail.provinceName + Detail.cityName +(Detail.address ?  Detail.address : '')}}</div>
                    <div slot="content"  style="color: #666" >{{ Detail.areaName?Detail.provinceName + Detail.cityName + Detail.areaName + (Detail.address ?  Detail.address : '') :Detail.provinceName + Detail.cityName + (Detail.address ?  Detail.address : '')}}</div>
                  </el-tooltip>
                </div>
                <span
                  @click="showMap"
                  style="marginLeft:5px;cursor:pointer;width:30px;height:26px"
                >
                  <img src="@/assets/public/map.jpg" alt />
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <btns
            :item="Detail"
            :type="6"
            @end="getDetail"
            @changeStatus="v => (state = v)"
          ></btns>
        </div>
        <div style="padding:0 20px;position: relative;">
          <div class="little-tips">联系时，请说明是在“经营帮”上看到的</div>
          <div v-if="Detail.updateTime===Detail.createTime" class="createTime color6">{{Detail.createTime | formatDate}}发布</div>
          <div v-else class="createTime color6">{{Detail.updateTime | formatDate}}更新</div>
        </div>
      </div>

      <div class="signUp_tab">
        <el-tabs
          v-model="activename"
          type="card"
          @tab-click="handleClick"
          id="pane"
        >
          <el-tab-pane label="工作内容" activeIndex="0" key="tab1">
            <el-col :span="24" v-if="Detail.workContent">
              <span class="label">工作内容：</span>
              <span class="context">{{Detail.workContent}}</span>
            </el-col>
            <div
              v-if="Detail.customFieldsList && Detail.customFieldsList.length"
            >
              <el-col
                :span="24"
                v-for="(field, index) in Detail.customFieldsList"
                :key="index"
                class="detail-item"
              >
                <span class="item-name">{{ field.title }}：</span>
                <span class="item-value" style="white-space: pre-line">{{
                  field.value
                }}</span>
              </el-col>
            </div>
            <el-col
              :span="24"
              class="detail-item"
              style="display: flex; margin-bottom: 0;"
              v-if="Detail.fileList && Detail.fileList.length"
            >
              <span class="item-name">附件：</span>
              <span style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(file, index) in Detail.fileList"
                  :key="index"
                  class="file-item"
                >
                  <div class="file-item-container">
                    <img
                      :src="fileIcon[file.name.split('.').pop().toLowerCase()]"
                      alt=""
                      class="file-icon"
                    />
                    <div class="file-info">
                      <div class="file-name">
                        <div class="fore">
                          {{ file.name.slice(0, file.name.lastIndexOf(".")) }}
                        </div>
                        <div class="back">
                          .{{ file.name.split(".").pop() }}
                        </div>
                      </div>
                      <div class="file-other">
                        <span class="file-size">{{
                          formatFileSize(file.size)
                        }}</span>
                        <span
                          class="file-download"
                          @click="$previewFile(file.fileUrl)"
                          >预览</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </el-col>
        <BaseEmptyData isDetail v-if="!Detail.workContent && !(Detail.customFieldsList && Detail.customFieldsList.length)&&!(Detail.fileList && Detail.fileList.length)"></BaseEmptyData>
          </el-tab-pane>

          <el-tab-pane label="联系方式" activeIndex="1" key="tab2">
            <el-row>
              <el-col :span="12" class="detail-item">
                <span class="item-name">联系人：</span>
                <span class="item-value">{{Detail.contactName|formatContactName}}</span>
              </el-col>
              <el-col :span="12" class="detail-item">
                <span class="item-name">联系电话：</span>
                <span class="item-value" v-if="showpNumber">{{Detail.contactNumber}}</span>
                <span class="item-value" v-else>{{ShowPhone(Detail.contactNumber)}}</span>
                <span style="color:#0286DF;cursor: pointer;margin-left:10px" v-if="!showpNumber" @click="ShowPhoneNumber" >查看</span>
              </el-col>
              <div
                v-if="Detail.contactFieldLists && Detail.contactFieldLists.length"
              >
                <el-col
                  :span="24"
                  v-for="(field, index) in Detail.contactFieldLists"
                  :key="index"
                  class="detail-item"
                >
                  <span class="item-name">{{ field.name }}：</span>
                  <span
                    class="item-value"
                    style="white-space: pre-line"
                    >{{ field.content }}</span
                  >
                </el-col>
              </div>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 推荐列表 -->
      <div class="recommendList">
        <div class="title">
          <div class="name">相关用工推荐</div>
          <div
            class="more"
            @click="
              $router.replace('/labour')
              reload()
            "
          >
            查看更多
            <img src="@/assets/teamIcon/more.png" alt="" />
          </div>
        </div>

        <div v-loading="loadingTrue">
          <el-row
            style="padding: 0px 20px 20px"
            :gutter="20"
            v-if="recommendedList.length"
          >
            <el-col
              v-for="(item, index) in recommendedList"
              :span="12"
              :key="index"
            >
              <card :item="item" :type="6"></card>
            </el-col>
          </el-row>
        </div>

        <BaseEmptyData
        isDetail
          v-if="!recommendedList.length && !loadingTrue"
        ></BaseEmptyData>
      </div>
    </div>

    <!-- 工作地址地图 -->
    <el-dialog
      center
      title="地图显示"
      :visible.sync="mapDiaVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <span>
        <i class="el-icon-location-outline"></i>
        <span>所在地区:</span>
        {{ Detail.address ? Detail.address : Detail.areaName?Detail.provinceName + Detail.cityName + Detail.areaName :Detail.provinceName + Detail.cityName + Detail.address }}
      </span>
      <Mapdetail
        ref="childDataDt"
        :center="mapCenter"
        :position="mapPosition"
        :text="text"
      ></Mapdetail>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mapDiaVisible = false">
          关 闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiFlexibleEmployment } from "@/api/apiFlexibleEmployment"
import { api } from "@/api/apiRecommendedList"
import "@/utils/previewFile"

export default {
  name: "LaborDetail",
  inject: ["reload"], // 引入App.vue 中的刷新页面的方法
  data() {
    return {
      showpNumber: false,
      showTooltip:false,
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png")
      },
      state: 1, // 数据状态：1 正常；2 下架； 3 删除
      isCanLookPhone: false,
      loadingTrue: false,
      Detail: {},
      // 地图经纬度信息
      mapCenter: [],
      mapPosition: [],
      text: {
        text: "",
        offset: [0, -50]
      },
      mapDiaVisible: false,
      recommendedList: []
    }
  },

  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    InByLetDialog: () => import("@/components/public/InquiryLetterDialog"), // 函询弹框
    btns: () => import("@/components/details/btns"), // 按钮组
    Pagination: () => import("@/views/Construction/components/Pagination"), // 分页
    EmptyData: () => import("@/components/public/UI/EmptyData"), // 数据被删除/下架显示的缺省图
    card: () => import("@/components/card/cardLabor.vue"), // 劳务用工card
    Mapdetail: () => import("@/components/public/components/mapDetail"),
  },
  created() {
    if (this.$route.query) {
      this.getDetail(this.$route.query.no)
    }
  },
  methods: {
      /**
     * @description:显示地图
     */
    showMap() {
      let temp = [Number(this.Detail.longitude), Number(this.Detail.latitude)]
      this.mapCenter = temp
      this.mapPosition.push(Number(temp[0]))
      this.mapPosition.push(Number(temp[1]))
      this.mapDiaVisible = true
    },
    //隐藏联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
    //查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    //内容超出时,hover显示所有文本信息
    handleShowTooltip(event){
      let cell = event.target.querySelector('.el-tooltip');
      this.showTooltip = cell.scrollWidth === cell.offsetWidth;
    },
    /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
    formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize / 1024 > 10) {
        return `${(fileSize / 1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
    loginIndex() {
      let data = {
        callBack: function () {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    // 隐藏号码中间4位数
    starPhone(phoneNum) {
      let str = String(phoneNum)
      return str.substr(0, 3) + "****" + str.substr(7)
    },
    // 点击'查看联系方式'按钮
    queryContactType() {
      let token = this.$store.state.token
      if (!token) {
        this.loginIndex()
      } else {
        this.isCanLookPhone = true
      }
    },
    async getDetail(no) {
      this.loadingTrue = true
      let res = await apiFlexibleEmployment.laborEmploymentDetail(no)
      this.Detail = res.data.data
      this.loadingTrue = false
      this.getRecommendedList()
    },
    handleBack() {
      const referrer = document.referrer
      if (referrer.includes("labourService")) {
        this.$router.replace("/labour")
      } else {
        window.location.href = referrer
      }
    },
    /**
     * 获取推荐列表
     */
    async getRecommendedList() {
      this.loadingTrue = true
      const { workNo, no: laborEmploymentNo, provinceNo } = this.Detail
      const params = {
        workNo, // 工种no
        laborEmploymentNo, // 当前劳务用工no
        provinceNo // 省编号
      }
      const res = await api.getLaborEmploymentRecommend(params)
      if (res.data.code === 200) {
        this.recommendedList = res.data.data.slice(0, 6)
      } else {
        this.$message.error("系统异常，请稍后再试")
        this.recommendedList = []
      }
      this.loadingTrue = false
    },
    getList() {
      this.getRecommendedList()
    }
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
div {
  box-sizing: border-box;
}
.color6 {
  color: #666666;
}
.single_hide {
  // 单行隐藏
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.FlexibleDetail_page {
  padding: 10px 0 0 0;
  width: 1200px;
  font-size: 16px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .leftBox {
    width: 1200px;
    .top_title {
      display: flex;
      align-items: center;
      height: 50px;
      font-size: 19px;
      border-bottom: 1px solid #eee;
      img {
        width: 22px;
        height: 22px;
        margin-right: 10px;
      }
    }
    .item_top {
      background-color: #fff;
      border: 1px solid #e4e7ed;
      .title {
        text-align: center;
        border-bottom: 1px dashed #e4e7ed;
        padding: 30px 0;
        position: relative;
        .RecruitmentStatus {
          position: absolute;
          top: 60px;
          right: 95px;
        }
        .name {
          display: flex;
          align-items: center;
          justify-content: center;
          .state {
            width: 51px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            display: inline-block;
            background-color: #409ee9;
            color: #ffffff;
            font-size: 12px;
          }
          .titleName {
            margin-left: 10px;
            font-size: 18px;
            color: #333333;
          }
        }
        .time {
          font-weight: normal;
          font-size: 16px;
          color: #ff6600;

          .time-icon {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            margin-bottom: -1px;
          }
        }
      }
      .detailBody {
        padding-left: 20px;
        padding-right: 20px;
        .single_hide {
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .color0 {
          color: #0286df;
          cursor: pointer;
        }
        .color3 {
          color: #333333;
        }
        .item_text {
          font-size: 14px;
          width: 100%;
          font-weight: 400;
          color: #666666;
          // line-height: 45px;
          display: flex;
          align-items: center;
          padding: 10px 0;
          .color3 {
            color: #333333;
          }
          .item_icon {
            width: 24px;
            height: 24px;
            padding: 0 10px;
          }
        }
        .top-text {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          color: #969696;
          .tips {
            padding-bottom: 20px;
            padding-left: 20px;
          }
          img {
            margin-right: 5px;
          }
          .num {
            color: #333;
            padding: 0 5px;
          }

          .fx {
            display: flex;
          }
          .ls {
            display: flex;
            margin-top: 10px;

            .lianxi {
              margin: 0 10px;
            }
          }
        }
      }
      .little-tips {
        border-top: 1px dashed #e4e7ed;
        padding-top: 10px;
        margin-bottom: 10px;
        color: #969696;
        font-size: 14px;
      }
      .createTime{
        font-size: 14px;
        color: #666666;
        position: absolute;
        right: 20px;
        top: 10px;
      }
      .tips {
        color: #969696;
        font-size: 14px;
      }
      .top_tit {
        margin-top: 20px;
        display: flex;
        align-items: center;
        .end_date {
          color: #666666;
          padding: 0 10px;
          font-size: 14px;
        }
        img {
          width: 50px;
          height: 20px;
        }
      }
      .top_content {
        position: relative;
        .state {
          width: 84px;
          height: 84px;
          position: absolute;
          top: -88px;
          right: 120px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .single_hide {
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item_text {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          .phoneBtn {
            color: #0286df;
            padding-left: 20px;
            cursor: pointer;
          }
        }
        .item_tag {
          color: #333333;
        }
      }
    }

    .signUp_tab {
      border: 1px solid #e4e7ed;
      background-color: #fff;
      margin-top: 10px;

      /deep/ .el-tabs__item {
        box-sizing: border-box;
        padding: 0 !important;
        margin: 0px 25px;
        font-size: 16px;
        font-family: Microsoft YaHei !important;
        font-weight: 400 !important;
        color: #000000;
        border-left: none;
        height: 40px;
        line-height: 40px;
        &:not(:first-child) {
          &:before {
            content: "";
            display: inline-block;
            height: 24px;
            border-left: 1px solid #e4e7ed;
            position: absolute;
            left: -23px;
            top: 8px;
          }
        }
      }
      /deep/ .el-tabs__item.is-active {
        color: #b79255;
        font-weight: 700;
        border-bottom: 2px solid #b79255;
      }
      /deep/ .el-tabs__item:hover {
        color: #b79255;
      }
      /deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
        border: none;
      }
      /deep/ .el-tabs {
        .el-tabs__header {
          margin: 0;
        }
        .el-tabs__content {
          padding: 0 20px;
        }
      }
      /deep/.el-col {
        display: flex;
        margin: 10px 0;
        .label {
          color: #666;
          font-size: 14px;
          min-width: 70px;
        }
        .context {
          color: #333;
          font-size: 14px;
          display: inline-block;
          word-break: break-all;
          .el-image {
            > img {
              width: 100px;
              height: 100px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
.detail-item {
    display: flex;
    .item-name {
      font-size: 14px;
      flex-shrink: 0;
      color: var(--FC6);
      // margin-right: 3px;
    }
    .item-value {
      color: #333;
      font-size: 14px;
    }
  }
.file-item {
    .file-item-container {
      box-sizing: border-box;
      width: 236px;
      display: flex;
      padding: 10px;
      margin: 0 10px 10px 0;
      background-color: #fafafa;
      font-size: 14px;
      border-radius: 4px;
      .file-icon {
        width: 33px;
        height: 40px;
      }
      .file-info {
        flex: 1;
        padding-left: 10px;
        line-height: 1.2;
        .file-name {
          margin-bottom: 10px;
          display: flex;
          color: var(--FC3);
          .fore {
            max-width: 148px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .back {
            flex-shrink: 0;
          }
        }
        .file-other {
          display: flex;
          justify-content: space-between;

          .file-size {
            color: var(--FC9);
          }

          .file-download {
            cursor: pointer;
            color: #0286df;
          }
        }
      }
    }
  }
.recommendList {
  margin-top: 10px;
  background-color: #ffffff;
  border: 1px solid #e4e7ed;
  .title {
    font-weight: normal !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0;
    border-bottom: 1px solid #e4e7ed;
    .name {
      color: #b79255;
      font-size: 16px;
      height: 15px;
      padding-left: 10px;
      border-left: 3px solid #b79255;
      line-height: 15px;
      margin: 10px 0px;
    }
    .more {
      cursor: pointer;
      font-size: 14px;
      color: #666666;
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
        width: 16px;
        height: 16px;
      }
    }
  }

  /deep/ .empty-data .nodata .message {
    line-height: 1;
  }
}
</style>
<style lang="scss">
.item_top {
  .el-button--primary {
    color: #fff;
    background-color: #b79255;
    border-color: #b79255;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.popperCustoms {
  padding: 5px 10px!important;
  &.is-light {
    background: #ffffff !important;
    border: 1px solid #666666;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0;
    opacity: 1 !important;
    color: #666666 !important;
  }
}
</style>